import { axios } from '@/services/axios';

const createServiceDefinition = async (formData, wholesalerID, scope) => {
    const response = await axios.post(
        `/ServiceProfile/OperatorPlatform/Wholesaler/${wholesalerID}/ServiceDefinition`,
        formData,
        {
            headers: {
                'X-RequestScope': scope,
            },
        },
    );
    return response;
};

export default createServiceDefinition;
